'use client';

import { usePrivate } from '@/components/private';
import { useGetOrganisationSettings } from '@/hooks/useGetOrganisationSettings';
import { OrganisationSettingTypeCode } from '@/apiClient';
import {
  EMemberIdentFlag,
  TBillingConfig,
  TMemberIdent,
} from '@/model/configuration';

export const useGetOrgSettings = () => {
  const { selectedOrganisationId } = usePrivate();

  const { data, isLoading, mutate } = useGetOrganisationSettings(
    selectedOrganisationId,
  );

  const billingSettingCode = [
    OrganisationSettingTypeCode.MembershipDateSeedDay,
    OrganisationSettingTypeCode.MembershipDateSeedMonth,
    OrganisationSettingTypeCode.RenewalPeriod,
    OrganisationSettingTypeCode.GracePeriod,
  ];

  const billingData = data?.data.filter(
    (setting) =>
      setting.settingTypeCode &&
      billingSettingCode.includes(setting.settingTypeCode as 9 | 10 | 11 | 12),
  );

  const memberIdent = data?.data.reduce((identData, setting) => {
    if (
      setting.settingTypeCode ===
      OrganisationSettingTypeCode.EnterpriseIdentPrefix
    ) {
      return { ...identData, identLabel: setting.value || '' };
    }

    if (
      setting.settingTypeCode ===
      OrganisationSettingTypeCode.EnterpriseIdentAutoCalcType
    ) {
      return {
        ...identData,
        memberIdent: Number(setting.value) ?? EMemberIdentFlag.AUTO_ASSIGN,
      };
    }
    if (
      setting.settingTypeCode ===
      OrganisationSettingTypeCode.EnterpriseIdentSeed
    ) {
      return { ...identData, seed: Number(setting.value) || 0 };
    }

    return identData;
  }, {} as TMemberIdent);

  const dateInstance = new Date();
  if (billingData) {
    dateInstance.setDate(
      Number(billingData[0]?.value) || dateInstance.getDate(),
    );
    dateInstance.setMonth(
      Number(billingData[1]?.value) || dateInstance.getMonth(),
    );
  }

  const autoMemberIdent = data?.data.find(
    (x) =>
      x.settingTypeCode ===
      OrganisationSettingTypeCode.EnterpriseIdentAutoCalcType,
  )?.value;

  return {
    memberIdent,
    billingInfo: {
      startDate: dateInstance,
      renewalPeriod: billingData && Number(billingData[2]?.value || 0),
      gracePeriod: billingData && Number(billingData[3]?.value || 0),
    } as TBillingConfig,
    isFetchSetting: isLoading,
    refetchBilling: mutate,
    autoMemberIdent: autoMemberIdent === '1',
  };
};
